import React from "react";
import { FaFilePdf, FaEye, FaLock } from "react-icons/fa";

const drawings = [
  {
    title: "BASEMENT RAFT SLAB BOTTOM B1 ADDITIONAL REINFORCEMENT DETAILS",
    category: "Rebar Detailing",
    image: "/drawings/sample1.png",
    pdf: "/drawings/pdf1.pdf",
  },
  {
    title: "AL DEEM DEVELOPMENT COMMUNITY FACILITIES",
    category: "BIM Modeling",
    image: "/drawings/sample2.png",
    pdf: "/drawings/pdf2.pdf",
  },
  {
    title: "FOOTING REINFORCEMENT DETAILS",
    category: "BIM Modeling",
    image: "/drawings/sample3.png",
    pdf: "/drawings/pdf3.pdf",
  },
  {
    title: "EYWA DUBAI - (B+G+3P+19+Roof) Plot No. 3460542 AT BUSINESS BAY, DUBAI, UAE",
    category: "BIM Modeling",
    image: "/drawings/sample4.png",
    pdf: "/drawings/pdf4.pdf",
  },
  {
    title: "JH-0031 Madinat Jumeirah Living (MJL)",
    category: "BIM Modeling",
    image: "/drawings/sample5.png",
    pdf: "/drawings/pdf5.pdf",
  },
];

export default function Projects() {
  return (
    <section className="bg-slate-50 py-24">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading Section */}
        <div className="text-center mb-16">
          <p className="uppercase tracking-[4px] text-[#C8A96B] font-semibold">
            Our Portfolio
          </p>

          <h1 className="text-5xl font-bold text-[#0A1A3F] mt-4">
            Sample Drawings & BBS
          </h1>

          <p className="max-w-3xl mx-auto mt-6 text-slate-600 text-lg leading-relaxed">
            Explore technical samples delivered across GCC and global markets by our multidisciplinary Engineering, featuring engineering documentation from VAMCO LLC, Falcosys Infotech Ltd, and Astra Engineering Consultants.
          </p>

          {/* Privacy Disclaimer Notice */}
          <div className="inline-flex items-center gap-2.5 bg-amber-50 border border-amber-200 text-amber-800 rounded-xl px-5 py-3 mt-8 text-sm max-w-2xl mx-auto text-left shadow-sm">
            <FaLock className="text-amber-600 flex-shrink-0" />
            <p className="font-medium">
              <strong>Data Security Notice:</strong> To maintain strict corporate compliance, all client names, commercial project identifiers, and proprietary data locations have been securely hidden or anonymized.
            </p>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {drawings.map((drawing, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition duration-300 border border-slate-100 flex flex-col justify-between"
            >
              <div>
                {/* Image & Hover Action Overlay */}
                <div className="relative overflow-hidden aspect-[4/3] bg-slate-100">
                  <img
                    src={drawing.image}
                    alt={drawing.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  />

                  {/* Hover Buttons */}
                  <div className="absolute inset-0 bg-[#0A1A3F]/70 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center gap-4">
                    {/* Preview Image Button */}
                    <a
                      href={drawing.image}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="View Image"
                      className="bg-white text-[#0A1A3F] p-4 rounded-full hover:bg-[#C8A96B] hover:text-white transition shadow-lg"
                    >
                      <FaEye className="text-lg" />
                    </a>

                    {/* Open PDF Button */}
                    <a
                      href={drawing.pdf || drawing.image}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Open PDF"
                      className="bg-white text-[#0A1A3F] p-4 rounded-full hover:bg-[#C8A96B] hover:text-white transition shadow-lg"
                    >
                      <FaFilePdf className="text-lg" />
                    </a>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="inline-block bg-slate-100 text-slate-600 text-xs font-semibold px-3 py-1 rounded-full">
                      {drawing.category}
                    </span>
                    <span className="text-[11px] font-mono text-slate-400 flex items-center gap-1">
                      <FaLock className="text-[9px]" /> Secured Sample
                    </span>
                  </div>

                  <h3 className="text-lg font-bold text-[#0A1A3F] leading-snug">
                    {drawing.title}
                  </h3>
                </div>
              </div>

              {/* Bottom Quick Link */}
              <div className="px-6 pb-6 pt-2 border-t border-slate-50">
                <a
                  href={drawing.pdf || drawing.image}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-xs font-semibold text-[#0A1A3F] hover:text-[#C8A96B] transition"
                >
                  <FaFilePdf /> View Full Document (PDF)
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center bg-white border border-slate-200 rounded-3xl p-12 max-w-4xl mx-auto shadow-sm">
          <h3 className="text-3xl font-bold text-[#0A1A3F] mb-4">
            Need Detailed Shop Drawings or Optimized BBS?
          </h3>

          <p className="text-slate-600 mb-8 max-w-xl mx-auto leading-relaxed">
            Contact our project management team today to receive code-compliant reinforcement engineering estimates customized for your development timeline.
          </p>

          <button className="bg-[#0A1A3F] hover:bg-[#13295C] text-white px-8 py-4 rounded-xl font-semibold transition duration-300 shadow-md">
            Request a Quote
          </button>
        </div>

      </div>
    </section>
  );
}